import { Component, OnInit } from '@angular/core';
import { ThemeConstantService } from '../../services/theme-constant.service';
import { AuthService } from 'src/app/authentication/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

  searchVisible: boolean = false;
  quickViewVisible: boolean = false;
  isFolded: boolean;
  isExpand: boolean;
  name: string;
  lastName: string;
  email: string;
  // Variable para determinar si el usuario solo tiene permiso external_reporting
  onlyExternalReports: boolean = false;
  // Lista de notificaciones (sin modificar)
  notificationList = [
    {
      title: 'Processing leads #5375',
      time: '2 days',
      icon: 'sync',
      color: 'ant-avatar-gold'
    },
    {
      title: 'Leads completed #5331',
      time: '8 min',
      icon: 'check',
      color: 'ant-avatar-cyan'
    },
    {
      title: 'New user registered',
      time: '7 hours',
      icon: 'user-add',
      color: 'ant-avatar-blue'
    },
    {
      title: 'Error processing leads #5762',
      time: '8 hours',
      icon: 'warning',
      color: 'ant-avatar-red'
    }
  ];
  
  notificationVisible: boolean = false;

  constructor(
    private themeService: ThemeConstantService,
    public authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
    this.themeService.isExpandChanges.subscribe(isExpand => this.isExpand = isExpand);
    this.name = localStorage.getItem('name')?.replace(/^"(.*)"$/, '$1');
    this.lastName = localStorage.getItem('lastName')?.replace(/^"(.*)"$/, '$1');
    this.email = localStorage.getItem('email');

    // Suponiendo que los permisos se guardan en localStorage (como array JSON)
    const permissionsStr = localStorage.getItem('permissions');
    if (permissionsStr) {
      const permissions: string[] = JSON.parse(permissionsStr);
      this.onlyExternalReports = permissions.length === 1 && permissions.includes('external_reporting');
    }
  }

  toggleFold() {
    this.isFolded = !this.isFolded;
    this.themeService.toggleFold(this.isFolded);
  }

  toggleExpand() {
    this.isFolded = false;
    this.isExpand = !this.isExpand;
    this.themeService.toggleExpand(this.isExpand);
    this.themeService.toggleFold(this.isFolded);
  }

  searchToggle(): void {
    this.searchVisible = !this.searchVisible;
  }

  quickViewToggle(): void {
    this.quickViewVisible = !this.quickViewVisible;
  }

  toggleNotifications(): void {
    this.notificationVisible = !this.notificationVisible;
  }

  redirectLogo(): void {
    if (this.onlyExternalReports) {
      this.router.navigate(['/apps/externalreports']);
    } else {
      this.router.navigate(['/dashboard']);
    }
  }

  logout(): void {
    this.authService.logout();
  }
}
